export const mediaLabel = "Eric's Media Appearances";

export const media = [
    {
        id: 0,
        title: "Meet Eric Hess - UCalgary Science Careers",
        description: "Meet Eric Hess! An astrophysics major who did his co-op at the Rothney Astrophysical Observatory. Hear what he has to say about his experience in the program and in his co-op. ☄️✨",
        year: "2025",
        month: "03",
        url: "https://www.instagram.com/reels/DHbh2c9PgXI/",
        hostedBy: "Instagram",
    },
    {
        id: 1,
        title: "'Amazing experience': Calgarians bask in partial solar eclipse at viewings across the city",
        description: "Eric Hess, an astrophysics intern at Rothney Astrophysical Observatory, said this was the biggest event he’s been a part of.",
        year: "2024",
        month: "04",
        url: "https://calgaryherald.com/news/calgarians-prepared-for-solar-eclipse-viewings-across-the-city",
        hostedBy: "Calgary Herald",
    },
    {
        id: 2,
        title: "'It does kind of put you in your place': Calgary comes out to catch glimpse of solar eclipse",
        description: "A rare solar eclipse was visible here in Calgary, albeit only partly. But that didn't stop many from seeking out a better look.",
        year: "2024",
        month: "04",
        url: "https://www.ctvnews.ca/calgary/article/it-does-kind-of-put-you-in-your-place-calgary-comes-out-to-catch-glimpse-of-solar-eclipse/",
        hostedBy: "CTV News",
    },
]